import { Stethoscope, Building2, TrendingUp, Home } from 'lucide-react';
import medSpaImage from '@/assets/industry-medspa.jpg';
import dentalImage from '@/assets/industry-dental.jpg';
import financialImage from '@/assets/industry-financial.jpg';
import realEstateImage from '@/assets/industry-realestate.jpg';

const Industries = () => {
  const industries = [
    {
      icon: Stethoscope,
      title: 'Med Spas & Aesthetics',
      description:
        'Showcase your treatments, build patient trust, and attract clients seeking premium aesthetic services.',
      stats: 'Avg. 200% increase in consultation bookings',
      image: medSpaImage,
    },
    {
      icon: Building2,
      title: 'Dental Practices',
      description:
        'Humanize your practice, educate patients, and become the trusted dental provider in your community.',
      stats: 'Avg. 150% growth in new patient inquiries',
      image: dentalImage,
    },
    {
      icon: TrendingUp,
      title: 'Financial Advisors',
      description:
        'Establish authority, simplify complex topics, and connect with high-net-worth individuals seeking guidance.',
      stats: 'Avg. 180% increase in qualified leads',
      image: financialImage,
    },
    {
      icon: Home,
      title: 'Real Estate Agents',
      description:
        'Stand out in a crowded market with stunning property content and personal brand development.',
      stats: 'Avg. 250% boost in listing engagement',
      image: realEstateImage,
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16">
          <span className="inline-block text-accent font-semibold text-sm uppercase tracking-wider mb-3 sm:mb-4">
            Who We Serve
          </span>
          <h2 className="font-display font-bold text-2xl sm:text-4xl lg:text-5xl text-foreground mb-4 sm:mb-6">
            Tailored Solutions for
            <span className="text-accent"> Your Industry & More</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            We understand the unique challenges and opportunities in your field. Our strategies are customized to resonate with your specific audience.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
          {industries.map((industry) => (
            <div
              key={industry.title}
              className="bg-card border border-border rounded-2xl overflow-hidden shadow-soft hover:shadow-medium transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Image */}
              <div className="h-28 sm:h-40 overflow-hidden">
                <img 
                  src={industry.image} 
                  alt={industry.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              <div className="p-4 sm:p-6">
                {/* Icon */}
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-hero rounded-xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform -mt-8 sm:-mt-10 relative z-10 shadow-lg">
                  <industry.icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary-foreground" />
                </div>

                {/* Content */}
                <h3 className="font-display font-bold text-sm sm:text-lg text-foreground mb-1 sm:mb-2">
                  {industry.title}
                </h3>
                <p className="text-muted-foreground text-xs sm:text-sm mb-3 sm:mb-4 leading-relaxed hidden sm:block">
                  {industry.description}
                </p>

                {/* Stats */}
                <div className="pt-2 sm:pt-3 border-t border-border">
                  <span className="text-[10px] sm:text-xs font-medium text-accent">{industry.stats}</span>
                </div>
              </div>
            </div>
          ))}

          {/* & More Card */}
          <div className="bg-gradient-hero border border-border rounded-2xl p-5 sm:p-8 shadow-soft hover:shadow-medium transition-all duration-300 hover:-translate-y-1 group flex flex-col items-center justify-center text-center col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-background/20 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
              <span className="text-2xl sm:text-3xl font-bold text-primary-foreground">+</span>
            </div>
            <h3 className="font-display font-bold text-lg sm:text-xl text-primary-foreground mb-2 sm:mb-3">
              & More
            </h3>
            <p className="text-primary-foreground/80 text-sm sm:text-base leading-relaxed">
              We serve businesses across all industries looking to elevate their brand through video content.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
